import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

if (environment.production) {
  document.write(
    '<script type="text/javascript">\n' +
      "    var clevertap = {event:[], profile:[], account:[], onUserLogin:[], notifications:[]};\n" +
      '    clevertap.account.push({"id": "' +
      environment.clevertap +
      '"});\n' +
      "    (function () {\n" +
      "      var wzrk = document.createElement('script');\n" +
      "      wzrk.type = 'text/javascript';\n" +
      "      wzrk.async = true;\n" +
      "      wzrk.src = ('https:' == document.location.protocol ? '" +
      "      https://d2r1yp2w7bby2u.cloudfront.net' : 'http://static.clevertap.com') + '/js/a.js';\n" +
      "      var s = document.getElementsByTagName('script')[0];\n" +
      "      s.parentNode.insertBefore(wzrk, s);\n" +
      "    })();\n" +
      "  </script>"
  );

  document.write(
    "<!-- Global site tag (gtag.js) - Google Analytics -->\n" +
      '<script async src="https://www.googletagmanager.com/gtag/js?id=UA-127761496-1"></script>\n' +
      "<script>\n" +
      "window.dataLayer = window.dataLayer || [];\n" +
      "function gtag(){dataLayer.push(arguments);}\n" +
      "gtag('js', new Date());\n" +
      "gtag('config', 'UA-127761496-1', {\n" +
      "  'linker': {\n" +
      "    'domains': ['tutored.me']\n" +
      "  }\n" +
      "});\n" +
      "</script>"
  );

  document.write(
    "<!-- Hotjar Tracking Code for www.tutored.me -->\n" +
      "<script>\n" +
      "   (function(h,o,t,j,a,r){\n" +
      "      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};\n" +
      "      h._hjSettings={hjid:1202749,hjsv:6};\n" +
      "      a=o.getElementsByTagName('head')[0];\n" +
      "      r=o.createElement('script');r.async=1;\n" +
      "      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;\n" +
      "      a.appendChild(r);\n" +
      "    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');\n" +
      "</script>"
  );
  // OLD zendesk
  // document.write(
  //   "<script>\n" +
  //     "function loadZendeskWidget() {\n" +
  //     '  let script = document.createElement("script");\n' +
  //     '  script.type = "text/javascript";\n' +
  //     '  script.id = "ze-snippet";\n' +
  //     "  script.async = true;\n" +
  //     '  script.src = "https://static.zdassets.com/ekr/snippet.js?key=d1997f2e-e228-4ec1-9b89-bdd020e3ef5b";\n' +
  //     '  document.getElementsByTagName("head")[0].appendChild(script);\n' +
  //     "};\n" +
  //     'window.addEventListener("load", function() {\n' +
  //     "  loadZendeskWidget();\n" +
  //     "})\n" +
  //     "</script>"
  // );

  enableProdMode();
} else {
  document.write(
    '<script type="text/javascript">\n' +
      "    var clevertap = {event:[], profile:[], account:[], onUserLogin:[], notifications:[]};\n" +
      '    clevertap.account.push({"id": "' +
      environment.clevertap +
      '"});\n' +
      "    (function () {\n" +
      "      var wzrk = document.createElement('script');\n" +
      "      wzrk.type = 'text/javascript';\n" +
      "      wzrk.async = true;\n" +
      "      wzrk.src = ('https:' == document.location.protocol ? '" +
      "      https://d2r1yp2w7bby2u.cloudfront.net' : 'http://static.clevertap.com') + '/js/a.js';\n" +
      "      var s = document.getElementsByTagName('script')[0];\n" +
      "      s.parentNode.insertBefore(wzrk, s);\n" +
      "    })();\n" +
      "  </script>"
  );
}

//
// document.write(`
//   <!-- TIMEKIT AND JQUERY-->
//   <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js" defer></script>
//   <script src="https://cdn.timekit.io/booking-js/v2/booking.min.js" defer></script>
// `);

platformBrowserDynamic().bootstrapModule(AppModule);
